import React from "react";
import { relationsByIds } from "../enums/relations.js";
import EditSvg from "./svg/edit.js";
import DeleteSvg from "./svg/delete.js";

export default function ProfileDependantsPopup({
  hadDependants,
  configuration,
  dependants,
  entrepriseContact,
  onEditDependant,
  onDeleteDependant,
  onAddDependant,
}) {
  const canAddDeleteModifyDependants = hadDependants === false || (configuration.empecherModificationDependants || 'false').toUpperCase() === 'FALSE';

  return (
    <div className="profile-div input-container profile-section-block" style={{ width: '100%' }}>
      <span className="profile-span">CONJOINT / DÉPENDANTS</span>
      <div className="profile-div" style={{ display: 'flex', marginTop: '2rem' }}>
        <div className="profile-entity-list-grid">
          {dependants.filter(d => !d.deleted).map(d => (
            <React.Fragment key={d.idDependant}>
              <div>
                <span className="profile-span profile-entity-list-name">{d.nom} {d.prenom} {d.relation === 0 ? "" : "(" + relationsByIds[d.relation].descriptionFr + ")"}</span>
              </div>
              <div>{canAddDeleteModifyDependants &&
                <EditSvg className="clickable primary-color-on-hover" onClick={e => {
                  onEditDependant(d);
                }} />}
              </div>
              <div>
                {canAddDeleteModifyDependants && <DeleteSvg className="clickable primary-color-on-hover" onClick={e => {
                  onDeleteDependant(d);
                }} />}
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className="profile-div">
        <div className="profile-div profile-label-wrapper">
          <span className="profile-span"></span>
        </div>
        <div style={{ display: 'grid', padding: '8px', width: '100%', justifyContent: 'center' }}>
          {canAddDeleteModifyDependants
            ? <span className="label primary clickable" style={{ textTransform: 'initial' }} onClick={e => {
              onAddDependant();
            }}>Cliquez ici pour ajouter un dépendant</span>
            : <span className="label primary" style={{ textTransform: 'initial' }}>{`Pour modifier vos dépendants, contacter la zec au ${entrepriseContact}.`}</span>
          }
        </div>
      </div>
    </div>
  );
}
